// extracted by mini-css-extract-plugin
export default {"LogoList":"fGgJ9orE47RUQhBwqVMU","LogoList_track":"MM5ZEsRREnLnM3RYdeV5","LogoList_scroll":"DGKTTYkcI2vouytoBjNc","LogoList_item":"dQ8AKCEDvereAMNEjgyo"};